// @flow
import {Autocomplete} from "formik-material-ui-lab";
import {AutocompleteRenderInputParams} from "@material-ui/lab";
import {TextField as MaterialTextField} from "@material-ui/core";
import {CheckboxWithLabel} from "formik-material-ui";
import React from "react";

const getGameFields = (touched, errors, opponents, teams,locations) => [
  {
    name: "date",
    type: "date",
    label: "Datum",
    format: "DD.MM.YYYY",
  },
  {
    name: "time",
    type: "time",
    label: "Spielbeginn",
  },
  {
    name: "opponent",
    type: "text",
    label: "Gegner",
    component: Autocomplete,
    options: opponents,
    getOptionLabel: (option) => option.name,
    renderInput: (params: AutocompleteRenderInputParams) => (
      <MaterialTextField
        {...params}
        error={touched["opponent"] && !!errors["opponent"]}
        helperText={touched["opponent"] && errors["opponent"]}
        label="Gegner"
        variant="filled"
      />
    ),
    autoSelect: true,
    autoHighlight: true,
  },
  {
    name: "team",
    type: "text",
    label: "Mannschaft",
    component: Autocomplete,
    options: teams,
    getOptionLabel: (option) => option.name,
    renderInput: (params: AutocompleteRenderInputParams) => (
      <MaterialTextField
        {...params}
        error={touched["team"] && !!errors["team"]}
        helperText={touched["team"] && errors["team"]}
        label="Mannschaft"
        variant="filled"
      />
    ),
    autoSelect: true,
    autoHighlight: true,
  },
  {
    name: "location",
    type: "text",
    label: "Ort",
    component: Autocomplete,
    options: locations,
    getOptionLabel: (option) => option.name,
    renderInput: (params: AutocompleteRenderInputParams) => (
      <MaterialTextField
        {...params}
        error={touched["location"] && !!errors["location"]}
        helperText={touched["location"] && errors["location"]}
        label="Ort"
        variant="filled"
      />
    ),
    autoSelect: true,
    autoHighlight: true,
  },
  {
    name: "isHomegame",
    type: "checkbox",
    Label: { label: "Heimspiel" },
    component: CheckboxWithLabel,
  },
];

const adminForms = {
  getGameFields
};

export default adminForms